/**
 * Tiny per-route meta tag hook. React-helmet is not installed and it's
 * overkill for a client-rendered app — this directly patches
 * <title> and <meta name="description">, restoring the defaults on
 * unmount so the previous route's tags don't leak.
 *
 * Usage (at the top of a page component):
 *
 *     useDocumentMeta({
 *       title: "Dr. Christy Vonta · Identity Alignment",
 *       description: "Take the free Identity Alignment Assessment to see...",
 *     });
 */
import { useEffect } from "react";

const DEFAULT_TITLE = "KISSED by C. Von — KCIS Clinical Intelligence System";
const DEFAULT_DESCRIPTION =
  "KISSED by C. Von — Clinical Intelligence System (KCIS). Premium hair, scalp, and wellness assessments by Christy Vonta.";

export function useDocumentMeta({ title, description } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    const metaEl = document.querySelector('meta[name="description"]');
    const prevDescription = metaEl ? metaEl.getAttribute("content") : DEFAULT_DESCRIPTION;

    if (title) document.title = title;
    if (metaEl && description) metaEl.setAttribute("content", description);

    return () => {
      document.title = prevTitle || DEFAULT_TITLE;
      if (metaEl) metaEl.setAttribute("content", prevDescription || DEFAULT_DESCRIPTION);
    };
  }, [title, description]);
}
